export default __webpack_public_path__ + "static/media/LOGO_SPLASH_53.102e7289.png";